/**
 * Safely parses a value into a number, returning 0 for empty/invalid input.
 */
export const safeParseFloat = (value: any): number => {
  if (value === undefined || value === null || value === "") return 0;
  const parsed = parseFloat(value.toString());
  return isNaN(parsed) ? 0 : parsed;
};
